var render = function render(){var _vm=this,_c=_vm._self._c;return _c('popup-frame',{ref:"popup",attrs:{"size":"md"}},[_c('div',{class:_vm.$style.login},[_c('bind-form',{ref:"form",on:{"bind-success":_vm.handleBindSuccess}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }